import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { questions } from '../../config/data';
import { initialize } from '../../features/counter/eqFiltersReducer';
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";

import AudioEngine from './audio/AudioEngine';
import QuestionNavigation from '../../UI/controllers/QuestionNavigation';

import '../../css/game.css';

function Game() {
    const { qSetKey, questionTitle } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isLandscape, setIsLandscape] = useState(window.innerWidth > 600);

    useEffect(() => {
        const handleResize = () => {
            setIsLandscape(window.innerWidth > 600);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        const questionSet = questions[qSetKey];
        if (!questionSet) {
            console.error(`Question set "${qSetKey}" not found.`);
            navigate('/');
            return;
        }

        const question = questionSet.list.find((q) => q.title === questionTitle);
        if (!question) {
            console.error(`Question "${questionTitle}" not found in set "${qSetKey}".`);
            navigate('/');
            return;
        }

        dispatch(initialize(question));

    }, [qSetKey, questionTitle, dispatch, navigate]);

    if (!isLandscape) {
        return (
            <div className="container">
                <div className="phone-sideway">
                    <h2>Please rotate your phone</h2>
                </div>
            </div>

        );
    }

    return (
        <div className="container">
            <div className="game-container">
                <div className="game-header">
                    <button className='home-button' onClick={() => navigate('/')}><MdOutlineKeyboardArrowLeft /></button>
                    <div className='game-title'>
                        <span className='title-icon'>{questions[qSetKey].icon}</span>
                        <h2>{questionTitle}</h2>
                    </div>
                </div>
                <div className="game-body">
                    <div className="eq"><AudioEngine /></div>
                </div>
                <div className="game-footer">
                    <QuestionNavigation />
                </div>
            </div>
        </div>
    );
}

export default Game;
